<template>
  <b-card class="rounded-lg">
    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
        <h4 class="text-dark m-0">
          Current Medications
        </h4>

        <div class="d-flex align-items-center">
          <b-button size="sm" variant="link" class="p-0">
            <feather-icon
              icon="PlusCircleIcon"
              size="20"
            />
          </b-button>

          <!-- <UserViewActionCard :user-data="consultationData" @update-user-data="$emit('update-user-data', $event)"></UserViewActionCard> -->
        </div>
      </div>
    </template>
    

    <div class="card-body">
      <div class="d-flex align-items-center mb-1">
        <b-img src="@/assets/images/health/meds.png" style="width: 25px"></b-img>
        <h4 class="ml-1 text-dark">Desloratadine (Clarinex)</h4>
      </div>

      <div class="d-flex align-items-center mb-1">
        <b-img src="@/assets/images/health/meds.png" style="width: 25px"></b-img>
        <h4 class="ml-1 text-dark">Ketorolac (Acular, Acuvail)</h4>
      </div>

      <div class="d-flex align-items-center mb-1">
        <b-img src="@/assets/images/health/meds.png" style="width: 25px"></b-img>
        <h4 class="ml-1 text-dark">Azelastine (Astelin, Astepro)</h4>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

// import UserViewActionCard from "./PatientOverviewActionCard.vue";

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownGroup,

    // UserViewActionCard,
  },
  props: {
    consultationData: {
      type: Object,
      required: true,
    },
  },
  setup() {},
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>
